import { FC } from 'react'

import { ProjectSource } from '@/api/models/auth/lib/auth.types'
import { useSelectedProject } from '@/api/models/main/hooks/useSelectedProject'

type Props = {
  personalAccountId: string
}

const ContentBlockPersonalAccount: FC<Props> = ({ personalAccountId }) => {
  const { selectedProject } = useSelectedProject()

  const personalAccountName = selectedProject?.personalAccounts.find(
    personalAccount => personalAccount.id === personalAccountId
  )?.name

  return (
    <>
      {personalAccountName && selectedProject.src === ProjectSource.BU && (
        <div>
          <p className="mb-8 font-bold text-grey-90 text-16">Лицевой счёт</p>
          <div className="line-clamp-2 whitespace-pre-line font-pro text-16">
            {personalAccountName}
          </div>
        </div>
      )}
    </>
  )
}

export { ContentBlockPersonalAccount }
